var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCricket({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 13,
    viewBox: "0 0 13 13",
    width: 13,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.13 2.506h1.02a.51.51 0 0 1 .51.51v9.473a.51.51 0 0 1-.51.51H1.13a.51.51 0 0 1-.51-.51V3.016a.51.51 0 0 1 .51-.51z",
    fill: "#ffcfa5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13 2.506c-.111 5.844-.111 9.065 0 9.664.166.898 1.3.829 1.02.829H1.13c-.282 0-.51-.191-.51-.426V2.932c0-.235.228-.426.51-.426z",
    fill: "#000",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.992 2.506h1.02a.51.51 0 0 1 .51.51v9.473a.51.51 0 0 1-.51.51h-1.02a.51.51 0 0 1-.51-.51V3.016a.51.51 0 0 1 .51-.51zm4.859 0h1.02a.51.51 0 0 1 .51.51v9.473a.51.51 0 0 1-.51.51h-1.02a.51.51 0 0 1-.51-.51V3.016a.51.51 0 0 1 .51-.51z",
    fill: "#ffcfa5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.988 2.506c-.11 5.844-.11 9.065 0 9.664.166.898 1.302.829 1.02.829h-1.02c-.282 0-.51-.191-.51-.426V2.932c0-.235.228-.426.51-.426zm4.863 0c-.112 5.844-.112 9.065 0 9.664.166.898 1.301.829 1.02.829h-1.02c-.282 0-.51-.191-.51-.426V2.932c0-.235.228-.426.51-.426z",
    fill: "#000",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.775 0c.052 0 .094.174.098.395h.569c.075 0 .135.076.135.17v.17c0 .094-.06.17-.135.17h-.57v.032c-.007.205-.048.363-.097.363H7.238c-.05 0-.093-.174-.097-.395h-.57c-.074 0-.134-.076-.134-.17v-.17c0-.094.06-.17.135-.17h.569V.364C7.15.158 7.19 0 7.239 0h3.537z",
    fill: "#ffcfa5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.577.735c0 .094-.06.17-.135.17h-.57v.032c-.007.205-.048.363-.097.363H7.238c-.05 0-.093-.174-.097-.395h-.57c-.074 0-.134-.076-.134-.17z",
    fill: "#000",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.958 0c.052 0 .094.174.098.395h.568c.076 0 .136.076.136.17v.17c0 .094-.06.17-.136.17h-.569v.032c-.008.205-.048.363-.097.363H1.421c-.051 0-.093-.174-.098-.395H.754C.68.905.62.829.62.735v-.17c0-.094.061-.17.135-.17h.57V.364C1.332.158 1.373 0 1.421 0z",
    fill: "#ffcfa5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76.735c0 .094-.06.17-.136.17h-.569v.032c-.008.205-.048.363-.097.363H1.421c-.051 0-.093-.174-.098-.395H.754C.68.905.62.829.62.735z",
    fill: "#000",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricket);
export default __webpack_public_path__ + "static/media/cricket.6d2ae73654937d4f9a8e75a8e3d43bb1.svg";
export { ForwardRef as ReactComponent };